import { z } from 'zod';
import { coerceBoolean } from '../../validation';

export const MycawInitialTypeformUpdateSchema = z.object({
  safeguardCheck: coerceBoolean(z.boolean()),
});
